(function () {
  if (window.__nativeShareInit) return;
  window.__nativeShareInit = true;
  'use strict';

  function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  function buildShareData(el) {
    const title = el.getAttribute("data-share-title") || document.title || "";
    const text  = el.getAttribute("data-share-text")  || "";
    const url   = el.getAttribute("data-share-url")   || location.href;
    return { title, text, url };
  }

  function toQuery(s) { return encodeURIComponent(s || ""); }

  // Prefer provided data-share-text; otherwise "Title - URL"
  function buildCombinedText({ title, text, url }) {
    const provided = (text || "").trim();
    if (provided) return provided;
    const parts = [];
    if ((title || "").trim()) parts.push(title.trim());
    if ((url || "").trim())   parts.push(url.trim());
    return parts.join(" - ");
  }

  function handleShareClick(e) {
    e.preventDefault();
    const data = buildShareData(e.currentTarget);
    const combinedText = buildCombinedText(data);

    if (navigator.share && typeof navigator.share === "function") {
      navigator.share({ title: data.title, text: combinedText }).catch(function(){});
      return;
    }

    // Fallback: mobile -> WhatsApp, desktop -> Email
    if (isMobile()) {
      const w = window.open("https://api.whatsapp.com/send?text=" + toQuery(combinedText), "_blank", "noopener,noreferrer");
      if (w) w.opener = null; // extra safety
    } else {
      // Subject is friendly; body is "Title - URL"
      const subject = (data.title && data.title.trim()) ? "Check this out: " + data.title.trim() : "";
      window.location.href = "mailto:?subject=" + toQuery(subject) + "&body=" + toQuery(combinedText);
    }
  }

  function attach(el) {
    if (el.__nativeShareBound) return;
    el.addEventListener("click", handleShareClick);
    el.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleShareClick(e); }
    });
    el.__nativeShareBound = true;
  }

  function init() {
    document.querySelectorAll("[data-open-share]").forEach(attach);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:select", init);
})();
